import React from "react";
import "./App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./components/home";
import HomePage from "./components/homePage";
import Navigation from "./components/Navbar";
import Main from "./components/Main";
import PolicyDialoguesFocus from "./components/PolicyDiaglogues";
import Contact from "./components/Contact";
import About from "./components/About"
import Publication from "./components/Publication";
import Events from "./components/Events";
import Advisory from "./components/Advisory";
import Association from "./components/Association";
import Policyweek from "./components/Policyweek";
import Week1 from "./components/policyweek/Week1";
import Week2 from "./components/policyweek/Week2";
import ScrollToTop from "./components/ScroolTOTop";
import Week3 from "./components/policyweek/Week3";
import PressR from "./components/policyweek/PressR";

function App() {
  return (
    <Router>
      {/* If you want Navbar on all pages, uncomment this */}
      {/* <Navigation /> */}
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Main/>} />
        <Route path="/home" element={<Home />} />
        <Route path="/homePage" element={<HomePage />} />
        <Route path="/policy-dialogues" element={<PolicyDialoguesFocus />} />
        <Route path="/contact" element={<Contact />} />
         <Route path="/about" element={<About />} />
          <Route path="/publications" element={<Publication />} />
           <Route path="/events" element={<Events />} />
            <Route path="/advisory-board" element={<Advisory />} />
             <Route path="/association" element={<Association />} />
             <Route path="/policyweek" element={<Policyweek/>}/>
             <Route path="/policybrief" element={<Week1/>}/>
              <Route path="/policybrief1" element={<Week2/>}/>
              <Route path="/policybrief2" element={<Week3/>}/>
              <Route path="/pib1" element={<PressR/>}/>
      </Routes>
    </Router>
  );
}

export default App;
